"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const cache_1 = tslib_1.__importDefault(require("./cache"));
const INITIAL_STATE = {
    pages: [],
};
class StateLayer {
    registerDatabase(key) {
        this.storage = new cache_1.default({
            storageName: key,
            storeName: 'page-draft',
        });
    }
    constructor({ storageName }) {
        this.history = Object.assign({}, INITIAL_STATE);
        this.registerDatabase(storageName);
    }
    saveState(id) {
        this.history.pages.push(id);
    }
    get(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const pageId = this.history.pages.find((key) => {
                return String(key) === String(id);
            });
            if (!pageId)
                return;
            return yield this.storage.get(pageId);
        });
    }
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.all(this.history.pages.map((id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return ({
                    id,
                    data: yield this.storage.get(id),
                });
            })));
        });
    }
    set(id, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.delete(id);
            yield this.storage.set(id, data);
            this.saveState(id);
        });
    }
    delete(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.storage.delete(id);
            this.history.pages = this.history.pages.filter((key) => String(key) !== String(id));
        });
    }
    clearAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.history.pages.map((id) => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield this.storage.delete(id); })));
            this.history = Object.assign({}, INITIAL_STATE);
        });
    }
    hasUpdates() {
        return this.history.pages.length > 0;
    }
}
exports.default = StateLayer;
//# sourceMappingURL=state.js.map